var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoVideo = function SvgNoVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 100,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M79.555 31.37c-8.39.05-16.91-.34-24.89-2.56s-15-6.39-21.43-11.26c-4.2-3.18-8-5.7-13.46-5.32a24.9 24.9 0 0 0-14.54 5.67c-6.93 6.07-5.88 17.29-3.11 25.21 4.16 11.86 16.84 20.12 27.61 25.49 12.45 6.22 26.13 9.83 39.83 11.91 12.06 1.83 27.45 3.15 37.859-4.69 9.57-7.21 12.191-23.67 9.851-34.79a13.66 13.66 0 0 0-4.92-8.33c-6.72-4.92-16.74-1.63-24.29-1.47-2.8.06-5.65.13-8.51.14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CFCFCF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.484 74.15v4.31M28.334 76.31h4.31M102.504 21.12v4.31M100.354 23.28h4.31"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M56.724 1.96a.98.98 0 1 0 0-1.96.98.98 0 0 0 0 1.96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.445 99.99c20.302 0 36.76-1.025 36.76-2.29s-16.458-2.29-36.76-2.29-36.76 1.025-36.76 2.29 16.458 2.29 36.76 2.29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.274 52.43a36.08 36.08 0 0 1 72.16 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "M96.464 66.84h-7.12V38.39h7.12a6.58 6.58 0 0 1 6.58 6.58v15.29a6.58 6.58 0 0 1-6.58 6.58M31.994 38.39h7.12v28.45h-7.12a6.58 6.58 0 0 1-6.58-6.58V44.97a6.58 6.58 0 0 1 6.58-6.58"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M64.355 82.6c16.662 0 30.17-13.508 30.17-30.17s-13.508-30.17-30.17-30.17-30.17 13.507-30.17 30.17c0 16.662 13.507 30.17 30.17 30.17"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D2D2",
    d: "m35.154 21.63 2.11-14.34a2 2 0 0 0-.31 0l-10.25 1.49c-1.54.23-3.08.46-4.63.67a.64.64 0 0 0-.67.64c-.8 5.56-1.67 11.1-2.42 16.66a3.66 3.66 0 0 1-3.12 3.36 6.06 6.06 0 0 1-5.63-1.43 2.92 2.92 0 0 1-.91-3.34 3.37 3.37 0 0 1 2.3-2 6.25 6.25 0 0 1 5.37.66l.28.17h.14c0-.16.09-.32.11-.49q1.44-9.73 2.86-19.48c.07-.46.21-.65.69-.72 3.87-.53 7.74-1.1 11.6-1.66L39.864.8h.34q.015.225 0 .45-1.8 11.75-3.54 23.51a3.2 3.2 0 0 1-1.8 2.35 6.31 6.31 0 0 1-6.72-.87c-2-1.87-1.54-4.45 1.06-5.4a6.16 6.16 0 0 1 5.53.57q.135.094.28.17s.07.04.14.05"
  })));
};
export default SvgNoVideo;